// extracted by mini-css-extract-plugin
export default {"card":"PiechartWidget_card__Jxt4d","chartArea":"PiechartWidget_chartArea__KLml+"};